"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractObject = /** @class */ (function () {
    function AbstractObject() {
    }
    //To remove _ from the field names
    AbstractObject.prototype.toJSON = function () {
        var obj = {};
        for (var _i = 0, _a = Object.keys(this); _i < _a.length; _i++) {
            var key = _a[_i];
            if (key.startsWith('_')) {
                obj[key.substring(1)] = this[key];
            }
            else {
                obj[key] = this[key];
            }
        }
        return obj;
    };
    return AbstractObject;
}());
exports.default = AbstractObject;
//# sourceMappingURL=AbstractObject.js.map